import {penaltyTypes} from '../../action-types';

const {SET_PENALTY_LIST, SET_PENALTY_DETAIL, SET_PENALTY_LIST_TOTAL} = penaltyTypes;

const initialState = {
  listPenalty: [],
  detailPenalty: {},
  totalPenalty: '',
};

const reducer = (state = initialState, action) => {
  const {type, payload} = action;
  switch (type) {
    case SET_PENALTY_LIST:
      return {...state, listPenalty: payload};
    case SET_PENALTY_DETAIL:
      return {...state, detailPenalty: payload};
    case SET_PENALTY_LIST_TOTAL:
      return {...state, totalPenalty: payload};
    default:
      return state;
  }
};

export default reducer;
